import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { isMobile } from '../utilities/helpers'

const backgroundImage = require('../../assets/images/tulip-red.jpeg')

export const NotFoundContainer = styled.div`
    padding-top: ${isMobile() ? '0' : '50px'};
    min-height: ${isMobile() ? '360px' : '600px'};
    background: url(${backgroundImage});
    background-size: cover;
`

export const NotFoundHeadline = styled.h1`
    color: #2F7317;
    font-size: ${isMobile() ? '1.7' : '3.5'}em;
    top: 50px;
    position: relative;
`

export const BackToLandingLink = styled(Link)`
    top: ${isMobile() ? '100' : '150'}px;
    position: relative;
    color: #2F7317;
    text-decoration: underline;
    font-size: ${isMobile() ? '1.1' : '1.5'}em;
    cursor: pointer;
    
    &:hover {
        color: #2F7317;
        text-decoration: underline;
    }
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/NotFoundPage.js